module.exports = __webpack_public_path__ + "static/lfsuh-c75d5e955bf524fe45737fa3d0b7d214.svg";